module.exports = __webpack_public_path__ + "assets/img/8950-sa.svg";